var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('details',{class:_vm.base.wrapper},[_c('summary',{class:_vm.base.summary,on:{"click":function($event){$event.preventDefault();}}},[_c('div',{class:_vm.base.summaryContent},[_c('div',{class:[
          _vm.base.item,
          _vm.base.click,
          !_vm.reverseSpacing ? _vm.base.col5 : _vm.base.col7,
          _vm.base.flex
        ],attrs:{"tabindex":0}},[_vm._t("summaryLeft",[_vm._v("Add summary here")])],2),(_vm.$slots.summaryRight)?_c('div',{class:[_vm.base.item, !_vm.reverseSpacing ? _vm.base.col7 : _vm.base.col5]},[_vm._t("summaryRight")],2):_vm._e()])])])}
var staticRenderFns = []

export { render, staticRenderFns }